import * as React from 'react';
import { lazy, Suspense } from 'react';

import { PDFLoadingFallback } from './PDFLoadingFallback';

// Dynamically import the PDF component to split the bundle
const PDFViewComponent = lazy(() => import('./PDFView').then((module) => ({ default: module.PDFView })));

interface Props {
  url: string;
  width: number;
}

export const PDFLoader: React.FC<React.PropsWithChildren<Props>> = ({ url, width }) => {
  return (
    <Suspense fallback={<PDFLoadingFallback />}>
      <PDFViewComponent url={url} width={width} />
    </Suspense>
  );
};
